var exports = {
  "kL": "xa15a2ab7--fe709b--container",
  "iE": "xa15a2ab7--fe709b--wrapper",
  "DD": "xa15a2ab7--fe709b--title",
};

module.exports = exports;
